// extracted by mini-css-extract-plugin
module.exports = {"draggable":"draggable_draggable__npYCg","header":"draggable_header__lxMTq","close":"draggable_close__7zDcy"};